import React from 'react';
import PropTypes from 'prop-types';
import { Box, Pagination, Typography } from '@mui/material';

/**
 * Barra de paginação compartilhada pelas telas de listagem - some
 * sozinha quando os dados cabem numa página só (numPages <= 1).
 */
const PaginationBar = ({ page, numPages, count, onChange }) => {
    if (!numPages || numPages <= 1) return null;

    return (
        <Box display="flex" justifyContent="center" alignItems="center" gap={2} mt={3} mb={1}>
            <Typography variant="caption" color="text.secondary">
                {count} registro(s) no total
            </Typography>
            <Pagination count={numPages} page={page} onChange={(e, value) => onChange(value)} color="primary" size="small" />
        </Box>
    );
};

PaginationBar.propTypes = {
    page: PropTypes.number.isRequired,
    numPages: PropTypes.number.isRequired,
    count: PropTypes.number.isRequired,
    onChange: PropTypes.func.isRequired
};

export default PaginationBar;
